// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__DrK4w","load8":"loader_load8__mWTxN"};